import React from 'react';
import type { SubscriptionMarket } from '../../types/payment.types';
import styles from './SubscriptionMarketSelector.module.scss';

interface SubscriptionMarketSelectorProps {
    markets: SubscriptionMarket[];
    selectedMarketCode: string;
    disabled?: boolean;
    onChange: (marketCode: string) => void;
}

const SubscriptionMarketSelector = ({
    markets,
    selectedMarketCode,
    disabled = false,
    onChange
}: SubscriptionMarketSelectorProps) => (
    <label className={styles.selector}>
        <span>Region</span>
        <select
            aria-label="Region"
            value={selectedMarketCode}
            disabled={disabled}
            onChange={(event) => onChange(event.target.value)}
        >
            {markets.map((market) => (
                <option key={market.code} value={market.code}>
                    {market.displayName} — {market.currency.toUpperCase()}
                </option>
            ))}
        </select>
    </label>
);

export default SubscriptionMarketSelector;
